import { create } from 'zustand'
import { deleteFile, getFilesUser, getFolderList, moveFileOrFolder, postFolder } from '../api/files'
import {
    FileInfo,
    FileLifeType,
    FileObjectDeleteOutputDTO,
    FileObjectMoveModel,
    FileObjectUserFolderOutputDTO,
    FolderCreateOutputDTO,
    FoUserFolderApiV1UserFolderFileObjectGetParams,
    FoUserFoldersDeleteApiV1UserFolderFileObjectDeleteParams,
    UserFolderMoveOutputDTO,
} from '../swagger/dtoGateway'

interface Actions {
    fetchDisk: (
        params: FoUserFolderApiV1UserFolderFileObjectGetParams,
    ) => Promise<FileObjectUserFolderOutputDTO>
    fetchFolderList: (params) => Promise<FileInfo[]>
    createFolder: (name: string) => Promise<FolderCreateOutputDTO>
    moveFileOrFolder: (data: FileObjectMoveModel) => Promise<UserFolderMoveOutputDTO>
    deleteFileOrFolder: (
        params: FoUserFoldersDeleteApiV1UserFolderFileObjectDeleteParams,
    ) => Promise<FileObjectDeleteOutputDTO>
    setIsRefreshFetchDisk: (isDone: boolean) => void
    setError: (error?: string) => void
    reset: () => void
}

interface State {
    error?: string

    isRefreshFetchDisk: boolean

    isLoadingFetchDisk: boolean
    // errorFetchDisk?: string
    disk?: FileObjectUserFolderOutputDTO

    isLoadingCreateFolder: boolean
    // errorCreateFolder?: string
    folders?: string[]

    isLoadingMoveFileOrFolder: boolean
    // errorMoveFileOrFolder?: string

    isLoadingDeleteFileOrFolder: boolean
    // errorDeleteFileOrFolder?: string

    folderList?: FileInfo[]
    isFetchFolderList: boolean
}

const initialState: State = {
    isRefreshFetchDisk: false,

    isLoadingFetchDisk: false,
    // errorFetchDisk: undefined,
    disk: undefined,

    isLoadingCreateFolder: false,
    // errorCreateFolder: undefined,
    folders: undefined,

    isLoadingMoveFileOrFolder: false,
    // errorMoveFileOrFolder: undefined,

    isLoadingDeleteFileOrFolder: false,
    // errorDeleteFileOrFolder: undefined,

    folderList: undefined,
    isFetchFolderList: false,
}

export const useDiskStore = create<Actions & State>()((set, get) => ({
    ...initialState,

    fetchDisk: async (params) => {
        try {
            set({
                disk: undefined,
                isLoadingFetchDisk: true,
                error: undefined,
            })
            const data = await getFilesUser(params)

            set({
                isLoadingFetchDisk: false,
                disk: data,
            })
        } catch (error) {
            set({
                disk: undefined,
                isLoadingFetchDisk: false,
                error: 'Произошла ошибка! Повторите попытку позже',
            })
        }
    },

    createFolder: async ({ name }) => {
        try {
            set({
                isRefreshFetchDisk: false,
                isLoadingCreateFolder: true,
                error: undefined,
            })
            const response = await postFolder({
                prefix: name,
                life_type: FileLifeType.PERMANENT,
            })

            if (!response.error) {
                set({
                    isRefreshFetchDisk: true,
                    isLoadingCreateFolder: false,
                    folders: response,
                })
            } else {
                set({
                    isLoadingCreateFolder: false,
                    error:
                        response.error === 'FileAlreadyExistsError'
                            ? 'Объект с таким названием уже существуют'
                            : 'Произошла ошибка!',
                })
            }
        } catch (error) {
            set({
                isLoadingCreateFolder: false,
                error: 'Произошла ошибка! Повторите попытку позже',
            })
        }
    },

    fetchFolderList: async (params) => {
        try {
            set({
                folderList: undefined,
                isFetchFolderList: true,
                error: undefined,
            })
            const response = await getFolderList({
                ...params,
                prefix: '/disk/',
                order_by: 'filename',
                desc: false,
                life_type: 'PERMANENT',
            })

            if (!response.error) {
                set({
                    folderList: response.files,
                    isFetchFolderList: false,
                })
            } else {
                set({
                    isFetchFolderList: false,
                    error:
                        response.error === 'FileAlreadyExistsError'
                            ? 'Объект с таким названием уже существуют'
                            : 'Произошла ошибка!',
                })
            }
        } catch (error) {
            set({
                isFetchFolderList: false,
                error: 'Произошла ошибка! Повторите попытку позже',
            })
        }
    },

    moveFileOrFolder: async (data) => {
        try {
            set({
                isRefreshFetchDisk: false,
                isLoadingMoveFileOrFolder: true,
                error: undefined,
            })
            const response = await moveFileOrFolder(data)
            if (response.success) {
                set({
                    isRefreshFetchDisk: true,
                    isLoadingMoveFileOrFolder: false,
                })
            } else {
                set({
                    isLoadingMoveFileOrFolder: false,
                    error:
                        response.error === 'FileAlreadyExistsError'
                            ? 'Объект с таким названием уже существуют.'
                            : 'Произошла ошибка!',
                })
            }
        } catch (error) {
            set({
                isLoadingMoveFileOrFolder: false,
                error: 'Произошла ошибка! Повторите попытку позже',
            })
        }
    },

    deleteFileOrFolder: async (params) => {
        try {
            set({
                isRefreshFetchDisk: false,
                isLoadingDeleteFileOrFolder: true,
                error: undefined,
            })
            await deleteFile(params)

            set({
                isRefreshFetchDisk: true,
                isLoadingDeleteFileOrFolder: false,
            })
        } catch (error) {
            set({
                isLoadingDeleteFileOrFolder: false,
                error: 'Произошла ошибка! Повторите попытку позже',
            })
        }
    },
    setIsRefreshFetchDisk: (isRefresh: boolean) => {
        set({
            isRefreshFetchDisk: isRefresh,
        })
    },

    setError: (error) => {
        set({
            error,
        })
    },
    reset: () => {
        set(initialState)
    },
}))
